export default __webpack_public_path__ + "static/media/DamasoNo15.a2d2f912.jpg";